import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '壮丽70年，老区焕新颜';

const route: RouteConfig = {
  path: '/2019GloriousSeventyYears',
  name: '2019GloriousSeventyYears',
  component: () => import('./RouterView.vue'),
  redirect: '/2019GloriousSeventyYears/Welcome',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Home',
      name: 'Home',
      component: () => import('./Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      name: 'Detail',
      component: () => import('./Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Welcome',
      name: 'Welcome',
      component: () => import('./Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
